import '../css/b2binvite.css';

import useDictionary from '../hooks/useDictionary';

import { useParams } from "react-router-dom";

export default function B2BInvite() {

    const dictionary = useDictionary();
    const params = useParams();

    return (
        <div className="b2b-invite">
            <div className="background">
                Wholesale
            </div>
            <div className="sub-header">
                {dictionary.B2B_HEADER}
            </div>
            <div className="title">
                {dictionary.B2B_T1}<br />{dictionary.B2B_T2}
            </div>
            <div className="text">
                {dictionary.B2B_INFO}
            </div>
            <div className="buttons">
                <a className="univ-button" href={`/${params.lang}/b2b-reg-form/`}>{dictionary.B2B_REG_BUTTON}</a>
            </div>
        </div>
    )
}